import { PanelMenu } from "primereact/panelmenu";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { transformToMenuSections } from "../../../../adapters/function-to-menu.adapter";
import { useFunctions } from "../../../../hooks/use-query-functions";
import "./index.css";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useAuthStore } from "presentation/stores/use-auth-store";

const MenuItems = () => {
  const {
    data: functions,
    isLoading,
    isError,
  } = useFunctions({
    limit: 100,
    sortBy: "order",
    sortOrder: "asc",
  } as BaseInputFilter);
  const [menuSections, setMenuSections] = useState<any[] | undefined>(
    undefined
  );
  const { userPermissions } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (functions?.data) {
      const sections = transformToMenuSections(
        functions.data,
        userPermissions
      );


      // Converter seções para formato PanelMenu
      const panelMenuItems = sections.map((section) => ({
        label: section.label,
        icon: section.icon,
        expanded: section.expanded,
        items: section.items.map((item) => ({
          label: item.label,
          icon: item.icon,
          command: () => {
            navigate(item.path);
          },
        })),
      }));


      setMenuSections(panelMenuItems);
    }
  }, [functions?.data, userPermissions, navigate]);

  console.log("MenuItems Rendered Test");
  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error fetching users.</p>;

  return <PanelMenu model={menuSections} className="menu" />;
};

export default MenuItems;
